import React, { Component } from 'react';
import { Row, Col, Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import './ForgotPasswordModal.css';
import i18n from 'i18n-react';
import { Button } from 'react-bootstrap';
import ResetPasswordService from '../../../services/resetPassword/ResetPasswordService';
/*eslint-disable*/

const propTypes = {
	close: PropTypes.func,
	showModal: PropTypes.bool.isRequired
};

class ForgotPasswordModal extends Component {

	constructor(props) {
		super(props);
		this.state = {
			isLoginFilled: true,
			login: '',
			sucessResetPassword: false,
			errorResetPassword: false,
			disableSubmit: false
		};
	}

	handleLoginChange = event => {
		this.setState({
			login: event.target.value
		});
	};

	validateLogin = () => {
		let isValidState = this.state.login.length > 9;
		this.setState({
			isLoginFilled: isValidState
		});
		return isValidState;
	};

	validate = event => {
		event.preventDefault();
		let isLoginValid = this.validateLogin();
		let isValid = isLoginValid
		if (isValid) {
			this.sendResetPassword(this.state.login);
		}
		return isValid;
	};

	sendResetPassword(loginValue) {
		this.setState({
			isLoading: true,
			disableSubmit: true
		});
		ResetPasswordService.resetPassword(loginValue)
			.then(() => {
				this.setState({
					sucessResetPassword: true,
					errorResetPassword: false,
					isLoading: false,
					disableSubmit: false
				});
			})
			.catch(() => {
				this.setState({
					errorResetPassword: true,
					isLoading: false,
					disableSubmit: false
				});
			});
	}

	onShow = () => {
		this.setState({
			sucessResetPassword: false,
			errorResetPassword: false,
			isLoginFilled: true,
			login: ''
		});
	}

	renderValidationMessage(isFieldFilled, message) {
		let footer = <Row id={`${this.props.id}__errorMessageFooter`} className="Field__message" />;

		if (!isFieldFilled) {
			footer = (
				<Row className="Field__message error fieldCpfTA">
					<Col id={`${this.props.id}__errorMessageFooter`} xs={12}>
						<span className="Field__invalidField">{i18n.translate(message)}</span>
					</Col>
				</Row>
			);
		}
		return footer;
	}

	renderSucessResetPassword() {
		let result = <div></div>
		if (this.state.sucessResetPassword) {
			result = (
				<div>
					<Row>
						<Col id={`${this.props.id}__sucessResetPassword`} xs={12}>
							<span className="txtAllingCenter sucessResetPasswordTitle">{i18n.translate('label.forgotPassword.sucessResetPasswordTitle')}</span>
							<span className="txtAllingCenter sucessResetPassword">{i18n.translate('label.forgotPassword.sucessResetPasswordPart1')}</span>
							<span className=" txtAllingCenter txtWordWrap sucessResetPassword">
								{i18n.translate('label.forgotPassword.sucessResetPasswordPart2')}
								<span className="sucessResetPassword emailBold">{i18n.translate('label.forgotPassword.sucessResetPasswordPart3')}</span>
							</span>
							<span className="txtAllingCenter sucessResetPassword marginButton">{i18n.translate('label.forgotPassword.sucessResetPasswordPart4')}</span>
						</Col>
						{this.renderButtonOkEntendi()}
					</Row>
				</div>
			);
		}
		return result;
	}

	renderErrorResetPassword() {
		let result = <div></div>
		if (this.state.errorResetPassword) {
			result = (
				<div>
					<Row>
						<Col id={`${this.props.id}__errorResetPassword`} xs={12}>
							<span className="txtAllingCenter errorResetPasswordTitle">{i18n.translate('label.forgotPassword.errorResetPasswordTitlePart1')}</span>
							<span className="txtAllingCenter errorResetPassword marginButton">{i18n.translate('label.forgotPassword.errorResetPasswordTitlePart2')}</span>
						</Col>
						{this.renderButtonOkEntendi()}
					</Row>
				</div>
			);
		}
		return result;
	}

	renderButtonOkEntendi() {
		return (
			<Button
				className="btnForgotPassword container"
				id="btnForgotPasswordModal"
				type="button"
				onClick={this.props.close}>
				{i18n.translate('label.forgotPassword.buttonOkEntendi')}
			</Button>
		)
	}

	renderButtonClose() {
		return (
			<div className='buttonClose'>
				<a onClick={this.props.close} target="_self">
					<img src='../styles/img/icon-close.svg' width="24" />
				</a>
			</div>
		)
	}

	renderLoading() {
		if (this.state.isLoading)
			return (
				<div>
					<div className="ModalLoad__icon loadReset">
						<i className="icon-spinner" />
					</div>
				</div>
			)
	}

	renderField() {
		if (!this.state.sucessResetPassword && !this.state.errorResetPassword) {
			return (
				<Row>
					<Col>
						<span className='txtAllingCenter'>{i18n.translate('label.forgotPassword.cpfOrTAresetPassword')}</span>
					</Col>
					<Col className='fieldCpfTA'>
						<input
							type="text"
							id={'_loginField'}
							onChange={this.handleLoginChange}
							onBlur={this.validateLogin}
							placeholder={i18n.translate('placeholder.cpfOrAzulFidelidade').toString()}
							className={`Field__input ${this.state.isLoginFilled ? 'Field__validInput' : 'Field__invalidInput'
								}`}
							maxLength={11}
						/>
					</Col>
					{this.renderLoading()}
					{this.renderValidationMessage(
						this.state.isLoginFilled,
						'components.login.cpfErrorMessage'
					)}
					<Col >
						<Button
							className="btnForgotPassword container"
							id="btnForgotPasswordModal"
							type="submit"
							disabled={!this.state.isLoginFilled || this.state.disableSubmit}>							
							{i18n.translate('label.forgotPassword.prosseguir')}
						</Button>
					</Col>
				</Row>
			)
		}
	}

	renderForm() {
		return (
			<div>
				<form onSubmit={this.validate}>
					<Row>
						<Row className='d-flex aling-items-center rowRedefinirSenha'>
							<Col >
								<span className='txtColorTitle txtAllingCenter'>{i18n.translate('label.forgotPassword.reset')}
									<span className='txtColorTitle txtColorTitleBold txtAllingCenter'>{i18n.translate('label.forgotPassword.passwordReset')}</span>
								</span>
							</Col>
							{this.renderButtonClose()}
						</Row>
						{this.renderField()}
						{this.renderSucessResetPassword()}
						{this.renderErrorResetPassword()}
					</Row>
				</form>
			</div>
		)
	}

	render() {
		return (
			<div>
				<Modal
					dialogClassName='dialogClass'
					onShow={this.onShow}
					show={this.props.showModal}
					onHide={this.props.close}
				>
					<div className='modalContainer bg-white'>
						{this.renderForm()}
					</div>
				</Modal>
			</div>
		);
	}
}

ForgotPasswordModal.propType = propTypes;

export default ForgotPasswordModal;


// WEBPACK FOOTER //
// ./src/components/login/components/ForgotPasswordModal.jsx